<div class="billing-hub-summary">
  <div class="header">
    <h3>Billing & Invoices</h3>
    <button mat-stroked-button (click)="loadBillingHubData()" [disabled]="loading">Refresh</button>
  </div>

  <div class="loading" *ngIf="loading">
    <mat-spinner diameter="20"></mat-spinner>
    <span>Loading billing records...</span>
  </div>

  <div class="error" *ngIf="!loading && loadError">
    <mat-icon>error</mat-icon>
    <span>{{ loadError }}</span>
  </div>

  <div class="empty-hint" *ngIf="!loading && !loadError && !hasAnyData() && !invoicesAvailable && !disputesAvailable">
    Billing hub endpoints are not available for this account yet. Records will appear here once enabled.
  </div>

  <div class="sections" *ngIf="!loading && !loadError">
    <div class="section">
      <h4>Recent invoices</h4>
      <div class="empty-hint" *ngIf="invoices.length === 0">No invoices available.</div>
      <div class="list-item" *ngFor="let invoice of invoices">
        <div class="meta">
          <strong>{{ invoice.amountDue | number : '1.2-2' }} {{ invoice.currency | uppercase }}</strong>
          <span>{{ invoice.paymentStatus || invoice.invoiceStatus }}</span>
        </div>
        <div class="links">
          <a *ngIf="invoice.hostedInvoiceUrl" [href]="invoice.hostedInvoiceUrl" target="_blank" rel="noopener">View invoice</a>
          <a *ngIf="invoice.invoicePdfUrl" [href]="invoice.invoicePdfUrl" target="_blank" rel="noopener">PDF</a>
        </div>
      </div>
    </div>

    <div class="section">
      <h4>Recent disputes</h4>
      <div class="empty-hint" *ngIf="disputes.length === 0">No disputes available.</div>
      <div class="list-item" *ngFor="let dispute of disputes">
        <div class="meta">
          <strong>{{ dispute.amount | number : '1.2-2' }} {{ dispute.currency | uppercase }}</strong>
          <span>{{ dispute.status }}</span>
        </div>
        <span class="reason">{{ dispute.reason }}</span>
      </div>
    </div>
  </div>
</div>
